import "./About.css";
import { useTheme, Image } from "@chakra-ui/react";

const About = () => {
    const theme = useTheme();
    return (
        <div
            className="about"
            id="about"
            style={{
                backgroundColor: theme.colors.secondary,
                color: theme.colors.primary,
            }}
        >
            <h1 className="sectionHeading">About me</h1>
            <div className="aboutContainer">
                <Image
                    // boxSize="220px"
                    src="profilePhotoCircle.png"
                    alt="Anna Munro"
                    className="profilePhoto"
                />
                <div className="aboutText">
                    <p className="aboutTextSection">
                        I'm a frontend developer with an eye for design and
                        precision, experienced in programming with React, React
                        Native, Typescript, GraphQL and NodeJS.
                    </p>
                    <hr className="horizontalRule" />
                    <p className="aboutTextSection">
                        I have over 15 years of experience in agile project
                        coordination, and stakeholder partnership management,
                        specialising in university global experiences,
                        international education delivery models and
                        international student recruitment in Europe and Latin
                        America.
                    </p>
                    <hr className="horizontalRule" />
                    <p className="aboutTextSection">
                        I am always eager to learn new technologies, and to
                        apply my skills and knowledge to challenging and
                        meaningful problems.
                    </p>
                    <hr className="horizontalRule" />
                    <p className="aboutTextSection">
                        When I'm not programming, I am a salsa dancer. I speak
                        Spanish fluently and can have a conversation in Italian
                        too.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About;
